import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "viewer"
};
const _hoisted_2 = {
  class: "viewer-other"
};
const _hoisted_3 = {
  class: "viewer-other"
};
import ImageItem from './ImageItem';
export default {
  __name: 'ImageViewer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '预览对比图',
      required: false
    },
    rightFile: {
      type: Array,
      default: () => {
        return [];
      }
    },
    leftFiles: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const close = () => {
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: __props.title,
        onClose: close,
        width: "60%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leftFiles, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_unref(ImageItem), {
            name: item.imgName,
            url: item.imgUrl
          }, null, 8, ["name", "url"])]);
        }), 128))]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rightFile, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createVNode(_unref(ImageItem), {
            name: item.imgName,
            url: item.imgUrl
          }, null, 8, ["name", "url"])]);
        }), 128))])])]),
        _: 1
      }, 8, ["model-value", "title"]);
    };
  }
};